'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _timestamp = require('../components/timestamp');

var _timestamp2 = _interopRequireDefault(_timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
* AgentEnded
*
* @Constructor
* @class AgentEnded
* @public
*/
var AgentEnded = function (_React$Component) {
  _inherits(AgentEnded, _React$Component);

  function AgentEnded() {
    _classCallCheck(this, AgentEnded);

    return _possibleConstructorReturn(this, (AgentEnded.__proto__ || Object.getPrototypeOf(AgentEnded)).apply(this, arguments));
  }

  _createClass(AgentEnded, [{
    key: 'render',


    /**
     * @returns {React.Element} render
     *
     * @private
     */
    value: function render() {
      var intl = this.props.intl;

      var agentName = this.props.agentName || intl.formatMessage({ id: 'Support:HelpBot:LiveEngage:DefaultAgentName' });
      return _react2.default.createElement(
        'div',
        { className: 'live-agent-display-container' },
        this.props.timestamp && _react2.default.createElement(_timestamp2.default, { msgType: this.props.msgType, timestamp: this.props.timestamp, marginless: true }),
        _react2.default.createElement(
          'div',
          { className: 'agent-display-text' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Support:HelpBot:LiveEngage:AgentEnded', values: { agentName: agentName } })
        )
      );
    }
  }]);

  return AgentEnded;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(AgentEnded);

/**
* Property definitions.
*
* @type {Object}
* @public
*/

AgentEnded.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  agentName: _propTypes2.default.string.isRequired,
  msgType: _propTypes2.default.string.isRequired,
  timestamp: _propTypes2.default.number
};